<ng-template>
  <ng-content />
  <ng-template [cdkPortalOutlet]="_portal" />
</ng-template>
